/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TUpdateProjectRequest,
  TUpdateProjectModel,
  IMappers,
  TUpdateProjectResponse,
  TUpdateProjectResponseData200,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createUpdateProjectModel(parameters: TUpdateProjectRequest): TUpdateProjectModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'promotions-flow-control',
    pathApi: '/v1/update-project/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IUpdateProjectOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TUpdateProjectRequest;
}

export async function fetchUpdateProject<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IUpdateProjectOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TUpdateProjectResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createUpdateProjectModel(parameters),
    config,
  )) as FetchResponse<TUpdateProjectResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TUpdateProjectResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TUpdateProjectResponse>;
}
